import { SearchModel } from '@smg-real-estate/hg-search-libs';

export function hasExtendedFiltersForDesktop(searchModel: SearchModel): boolean {
  return (
    !!searchModel.surfaceLivingRange ||
    !!searchModel.surfacePropertyRange ||
    !!searchModel.buildYearRange ||
    !!searchModel.volumeRange ||
    !!searchModel.floorType ||
    searchModel.facilitiesRequired.length > 0 ||
    searchModel.objectTypes.length > 0
  );
}

export function hasExtendedFiltersForMobile(searchModel: SearchModel): boolean {
  return (
    hasExtendedFiltersForDesktop(searchModel) ||
    !!searchModel.radius ||
    !!searchModel.priceRange ||
    !!searchModel.numberOfRooms ||
    !!searchModel.numberOfApartments
  );
}

export function formatResultCount(count: number | undefined, locale: string): string {
  if (count === undefined) {
    return '';
  }

  if (count >= 1000) {
    if (locale.includes('en')) {
      return '1.000+';
    } else {
      return '1’000+';
    }
  }

  return count.toString();
}
